import { Space } from '../../space';
import Tag from '../Tag';

type P = {
  tags: TagItem[];
};

type TagItem = {
  id?: string;
  name: string;
};

const TagList = ({ tags }: P) => (
  <Space size={['xs', 'xs']} wrap>
    {tags.map((tagItem) => (
      <Tag key={tagItem.id ?? tagItem.name}>{tagItem.name}</Tag>
    ))}
  </Space>
);

export default TagList;
